<template>
  <div class="order-info">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-number" class="details-label">{{ 'order_number' | i18n }}</label>
        <span id="order-number">{{ order.orderDefaultNumber }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-offer" class="details-label">{{ 'order_type_full' | i18n }}</label>
        <span id="order-offer">{{ getOfferDescription(order.offer) }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-date" class="details-label">{{ 'order_date' | i18n }}</label>
        <span id="order-date">{{ order.createdDate | formatUnixDate('DD.MM.YY HH:mm') }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-delivery-date" class="details-label">{{ 'date_of_delivery' | i18n }}</label>
        <span id="order-delivery-date">{{ order.dateOfDelivery | formatUnixDate('DD.MM.YY HH:mm') }}</span>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-customer" class="details-label">{{ 'customer_number' | i18n }}</label>
        <span id="order-customer">{{ order.customerNumber }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-name1" class="details-label">{{ 'name1' | i18n }}</label>
        <span id="order-name1">{{ order.name1 }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-name2" class="details-label">{{ 'name2' | i18n }}</label>
        <span id="order-name2">{{ order.name2 }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-matchcode" class="details-label">{{ 'customer_matchcode' | i18n }}</label>
        <span id="order-matchcode">{{ order.matchcode }}</span>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-street" class="details-label">{{ 'street' | i18n }}</label>
        <span id="order-street">{{ order.street }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-zip" class="details-label">{{ 'zip_short' | i18n }}</label>
        <span id="order-zip">{{ order.zip }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-city" class="details-label">{{ 'city' | i18n }}</label>
        <span id="order-city">{{ order.city }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-state" class="details-label">{{ 'state' | i18n }}</label>
        <span id="order-state">{{ order.state }}</span>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-information1" class="details-label">{{ 'information' | i18n }}</label>
        <span id="order-information1">{{ order.information1 }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-information2" class="details-label">{{ 'information2' | i18n }}</label>
        <span id="order-information2">{{ order.information2 }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-details" class="details-label">{{ 'ordering_information' | i18n }}</label>
        <b-form-textarea id="order-details" v-model="order.details" rows="3" max-rows="3" plaintext />
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-text" class="details-label">{{ 'order_text' | i18n }}</label>
        <b-form-textarea id="order-text" v-model="order.orderText" rows="3" max-rows="3" plaintext />
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-representative" class="details-label">{{ 'representative' | i18n }}</label>
        <span id="order-representative">{{ order.salesRepresentative }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-value-days" class="details-label">{{ 'value_days' | i18n }}</label>
        <span id="order-value-days">{{ order.valueDays }}</span>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <label for="order-export" class="details-label">{{ 'exported' | i18n }}</label>
        <span id="order-export">{{ (order.isExported ? 'yes' : 'no') | i18n }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';
import { ORDER_OFFER_TYPES } from '../../../../../constants';

export default {
  name: 'OrderInfo',
  components: { BFormTextarea },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getOfferDescription(offer) {
      const orderOffer = ORDER_OFFER_TYPES.find(t => t.value === offer);
      return orderOffer ? orderOffer.name : null;
    }
  }
};
</script>

<style scoped lang="scss">
.order-info,
textarea {
  font-size: 0.875rem;
}

.details-label {
  display: block;
  margin-bottom: 4px;
}

[class*='col-'] {
  margin-bottom: 20px;
}

@media (max-width: 1440px) {
  .order-info {
    font-size: 0.813rem;
  }
}
</style>
